import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Spin } from 'antd';
import { useDocument } from 'react-firebase-hooks/firestore';

import Client from 'containers/app/client';
import FormActions from 'components/form-actions';
import { zip } from 'utils/form';

import schema from './schema';
import fields from './fields';
import Form from './form';

const handleValues = async (values) => {
  await Client.setUserProfile({ ...values });
};

const Component = ({ user, onSubmit, onBack }) => {
  const uploadTo = `user/${user.uid}/referenceDocuments/`;
  const ref = Client.dbProfile();
  const [doc, loading, error] = useDocument(ref);

  if (loading) return <Spin />;
  if (error) throw error;

  const initialValues = zip(fields, doc.data());

  const handleSubmit = (values, actions) => {
    onSubmit(values, actions, handleValues);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ values, ...rest }) => {
        return (
          <Form {...rest} values={values} uploadTo={uploadTo}>
            <FormActions
              onBack={() => {
                onBack(values, handleValues);
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

Component.propTypes = {
  user: PropTypes.shape({ uid: PropTypes.string.isRequired }).isRequired,
  onSubmit: PropTypes.func,
  onBack: PropTypes.func,
};

Component.defaultProps = {
  onSubmit: () => {},
  onBack: () => {},
};

export default Component;
